import { Spinner } from 'flowbite-react'
import React from 'react'

export const LoadingUi = () => {
  return (
    <>
      <Spinner aria-label="Spinner button example" color='purple' />
      <span className="pl-3">
        chargement...
      </span>
    </>
  )
}


export const ButtonUi = ({disabled = false, isLoading = false, bColor = 'bg-primary', onClick, children}) => {
  return (
    <button
      type="submit"
      disabled={disabled || isLoading}
      onClick={onClick}
      className={
        `w-full flex ${disabled && ' cursor-not-allowed'} ${isLoading && ' cursor-wait'} justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${bColor} focus:outline-none`
      }
    >
      {!isLoading && children}
      {isLoading && <LoadingUi/>}
    </button>
  )
}
